import { FC } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import { Features } from 'APP/packages/features/Features';
import { RouterLink } from 'APP/router/constants';

import Article from './Article';
import { ArticlePreview } from './ArticlePreview/ArticlePreview';

export const ChannelPopups: FC = () => {
  const { id } = useParams<{ id: string; messageId: string }>();

  return (
    <Routes>
      <Route
        path={'article-preview/:messageId'}
        element={<ArticlePreview groupId={id} />}
      />
      {Features.isArticleEnabled() && (
        <Route
          path={'article'}
          element={<Article groupId={id} />}
        />
      )}
      {Features.isArticleEnabled() && (
        <Route
          path={'article/:messageId'}
          element={<Article groupId={id} />}
        />
      )}

      <Route path="/"></Route>

      <Route
        path="*"
        element={
          <Navigate
            to={{
              pathname: RouterLink.Main,
            }}
            replace
          />
        }
      />
    </Routes>
  );
};
